<template>
    <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
                <div class="d-flex flex-column justify-content-center mr-auto">
                <h5 class="mb-0"></h5>
                </div>
                <div class="d-flex flex-column justify-content-center">
                    <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มสิทธิ์การเข้าถึง</a>
                </div>
            </div>
            <div class="card-body">
                <tableRoleAdmin @edit-submitted="getFormEditRoleAdmin"  @block-submitted="blockRoleAdmin" @clear-reload="clearReload" @mange-submitted="mangeRoleAdmin" v-bind="sendDataTable" />
            </div>
        </div>
        <a-modal v-model="visible" :title="formTitle" footer="">
            <formRoleAdmin @close-form="closeModal" @return-form="submitForm" v-bind="sentDataForm"/>
        </a-modal>
        <!-- <a-modal v-model="visibles" :title="formTitle" footer="">
            <formMangeRole @close-form="closeModal" />
        </a-modal> -->
    </div>
</template>

<script>
import formRoleAdmin from './formRoleAdmin'
// import formMangeRole from './formMangeRole'
import tableRoleAdmin from './tableRoleAdmin'
import apiClient from '@/services/api'
import useNoti from '@/services/plugin/notification'
import { Modal } from 'ant-design-vue'
export default {
  components: {
    formRoleAdmin,
    tableRoleAdmin,
    // formMangeRole,
  },
  data() {
    return {
      formTitle: '',
      mangeData: '',
      visible: false,
      // visibles: false,
      isloading: false,
      formAdminError: false,
      varidateCheck: [],
      formLayout: 'horizontal',
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      reloadTable: false,
      form: {
        name: '',
        status: '',
      },
      rules: {
        name: [
          { required: true, message: 'กรอกชื่อสิทธิ์การเข้าถึง', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    sentDataForm: function () {
      return {
        form: this.form,
        isloading: this.isloading,
        rules: this.rules,
        formLayout: this.formLayout,
        labelCol: this.labelCol,
        wrapperCol: this.wrapperCol,
        error: this.formAdminError,
        validate: this.varidateCheck,
      }
    },
    sendDataSumDeposit: function() {
      return {
        isReload: this.reloadTable,
      }
    },
    sendDataTable: function() {
      return {
        isReload: this.reloadTable,
      }
    },
  },
  methods: {
    showModal(event) {
      var title = (event === 'insert') ? 'เพิ่มสิทธิ์การเข้าถึง' : (event === 'edit') ? 'เเก้ไขสิทธิ์การเข้าถึง' : ''

      if (event === 'insert') {
        this.form = {
          id: '',
          username: '',
        }
      }
      this.formTitle = title
      this.visible = true
    },
    async getRoleAdmin(id) {
      await apiClient.get(`/roleAdmin/${id}`, {}).then(response => {
        const res = response.data
        if (res.code === '000') {
          const DataRoleAdmin = res.responseData.data[0]
          this.form = {
            id: DataRoleAdmin.id,
            name: DataRoleAdmin.name,
            status: DataRoleAdmin.status,
          }
        }
      }).catch(err => {
        useNoti('error', 'Error', err.message)
      })
    },
    async getFormEditRoleAdmin(id) {
      await this.getRoleAdmin(id)
      this.showModal('edit')
    },
    async submitForm(result) {
      this.isloading = !this.isloading

      const type = (this.formTitle === 'เพิ่มสิทธิ์การเข้าถึง') ? 'POST' : (this.formTitle === 'เเก้ไขสิทธิ์การเข้าถึง') ? 'PUT' : ''

      const sentData = {
        name: result.form.name,
        status: true,
      }

      if (type === 'POST') {
        await apiClient.post('/roleAdmin/insertRoleAdmin', sentData).then(response => {
          this.isloading = !this.isloading
          // this.loading = false
          if (response.data.code === '000') {
            this.clearReload()
            useNoti('success', 'Success', response.data.message)
            this.visible = false
          } else {
            useNoti('error', 'Error', response.data.message)
          }
        }).catch(err => {
          useNoti('error', 'Error', err.message)
        })
      } else if (type === 'PUT') {
        sentData.status = this.form.status
        await apiClient.put(`/roleAdmin/updateRoleAdmin/${result.form.id}`, sentData).then(response => {
          this.isloading = !this.isloading
          if (response.data.code === '000') {
            this.clearReload()
            useNoti('success', 'Success', response.data.message)
            this.visible = false
          } else {
            useNoti('error', 'Error', response.data.message)
          }
        }).catch(err => {
          useNoti('error', 'Error', err.message)
        })
      }
    },
    async blockRoleAdmin(result) {
      const sentData = {
        name: result.name,
        status: !result.status,
      }
      Modal.confirm({
        title: 'ยืนยัน',
        content: 'คุณต้องการอัปเดทรายการนี้ใช่หรือไม่?',
        okText: 'ใช่',
        okType: 'danger',
        cancelText: 'ไม่',
        onOk: () => {
          apiClient.put(`/roleAdmin/updateRoleAdmin/${result.id}`, sentData).then(response => {
            if (response.data.code === '000') {
              this.clearReload()
              useNoti('success', 'Success', response.data.message)
              this.visible = false
            } else {
              // this.setErrorForm(response.data.responseData, response.data.message)
              useNoti('error', 'Error', response.data.message)
            }
          }).catch(err => {
            useNoti('error', 'Error', err.message)
          })
        },
      })
    },
    // showModalMange(event) {
    //   var title = (event === 'mange') ? 'จัดการสิทธิ์พนักงาน' : ''
    //   this.formTitle = title
    //   this.visibles = true
    // },
    // async getMangeRoleAdmin(roleAdminId) {
    //   await apiClient.get(`/manageMenu/groupMenu`, {}).then(response => {
    //     const res = response.data
    //     if (res.code === '000') {
    //       const DataRoleAdmin = res.responseData.data
    //       this.mangeData = DataRoleAdmin
    //     }
    //   }).catch(err => {
    //     useNoti('error', 'Error', err.message)
    //   })
    // },

    // async mangeRoleAdmin(id){
    mangeRoleAdmin(id) {
      this.$router.push({
        path: `/admin/roleAdmin/formMangeRole/${id}`,
      })
      // await this.getMangeRoleAdmin(id)
      // this.showModalMange('mange')
    },
    clearReload() {
      this.reloadTable = !this.reloadTable
    },
    closeModal() {
      this.visible = false
    },
    setErrorForm(responseData, message) {
      if (responseData.varidateCheck) {
        this.formAdminError = !this.formAdminError
        this.varidateCheck.message = message
        this.varidateCheck.validate = responseData.varidateCheck
      }
    },
  },
}
</script>

<style>

</style>
